import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const steps = [
  {
    number: '01',
    title: 'Book Your Appointment',
    desc: 'Call us or complete our online form. We\'ll confirm your appointment within the hour and provide an upfront quote — no hidden fees, ever.',
    icon: 'ri-calendar-check-line',
  },
  {
    number: '02',
    title: 'Technician Arrives On Time',
    desc: 'Our certified technician arrives at your home in a BBM Services branded vehicle. We introduce ourselves, explain the process, and protect your space before we start.',
    icon: 'ri-truck-line',
  },
  {
    number: '03',
    title: 'Thorough Inspection First',
    desc: 'Before cleaning, we perform a full inspection of your chimney, ducts, or dryer vent. We document findings with photos and explain everything we discover.',
    icon: 'ri-search-eye-line',
  },
  {
    number: '04',
    title: 'Professional Cleaning Performed',
    desc: 'Using professional-grade equipment, we perform a complete cleaning — removing buildup, blockages, debris, and contaminants. We clean up after ourselves completely.',
    icon: 'ri-tools-line',
  },
  {
    number: '05',
    title: 'Final Report & Recommendations',
    desc: 'After the job, we walk you through our findings, provide a written report with before & after photos, and give you honest maintenance recommendations.',
    icon: 'ri-file-list-3-line',
  },
];

export default function ProcessTimeline() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section className="py-24 bg-white" id="process">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`text-center mb-16 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 text-brand-amber text-xs font-bold uppercase tracking-widest mb-4">
            <div className="h-px w-8 bg-brand-amber" />
            How It Works
            <div className="h-px w-8 bg-brand-amber" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-brand-dark mb-4">
            Our Simple 5-Step Process
          </h2>
          <p className="text-brand-warm-gray text-lg max-w-2xl mx-auto">
            From booking to completion, we make the entire experience easy, transparent, and hassle-free for Jacksonville homeowners.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* Connector line */}
          <div className="hidden lg:block absolute left-[60px] top-8 bottom-8 w-px bg-stone-200" />

          <div className="space-y-8">
            {steps.map((step, i) => (
              <div
                key={step.number}
                className="flex gap-6 lg:gap-10 items-start"
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                {/* Step number */}
                <div className="flex-shrink-0 flex flex-col items-center">
                  <div className="w-[72px] h-[72px] flex items-center justify-center bg-brand-amber rounded-xl text-white relative z-10">
                    <i className={`${step.icon} text-2xl`} />
                  </div>
                  <div className="font-serif text-xs font-bold text-brand-warm-gray/50 mt-1">{step.number}</div>
                </div>

                {/* Content */}
                <div className="flex-1 pb-6 lg:pb-0">
                  <div className={`p-6 lg:p-8 rounded-xl border transition-all hover:border-brand-amber/40 hover:bg-amber-50/30 ${i === 0 ? 'bg-amber-50 border-brand-amber/20' : 'bg-stone-50 border-stone-200'}`}>
                    <h3 className="font-semibold text-brand-dark text-xl mb-2">{step.title}</h3>
                    <p className="text-brand-warm-gray text-sm leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
